<template>
  <v-flex lg12>
    <!-- Create / Edit Module Dialog -->
    <v-dialog v-model="addModule" max-width="480px">
      <v-card class="module-dialog">
        <!-- Header -->
        <div class="modal-header">
          <div class="modal-header__left">
            <div class="modal-header__icon-wrap">
              <v-icon class="modal-header__icon">extension</v-icon>
            </div>
            <div>
              <div class="modal-header__title">
                {{ mod._id ? 'Edit Module' : 'Create Module' }}
              </div>
              <div class="modal-header__sub">{{ mod._id ? 'Update module name' : 'Add a new feature module' }}</div>
            </div>
          </div>
          <v-btn icon flat class="modal-close-btn" @click="addModule = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-divider class="modal-divider"></v-divider>

        <div class="modal-body">
          <form-text-field
            v-model="mod.module"
            label="Module Name"
            placeholder="e.g. visitor_management"
            prepend-inner-icon="label"
            hint="Use lowercase with underscores"
            persistent-hint
            readonly-style
          ></form-text-field>
        </div>

        <v-divider class="modal-divider"></v-divider>
        <div class="modal-footer">
          <v-btn flat class="modal-cancel-btn" @click="addModule = false">Cancel</v-btn>
          <v-btn depressed color="primary" class="modal-action-btn" @click="createModule">
            <v-icon left small>{{ mod._id ? 'save' : 'add' }}</v-icon>
            {{ mod._id ? 'Update' : 'Create' }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Modules table card -->
    <v-card class="modern-table-card">
      <div class="modern-table-toolbar">
        <div class="modern-search-wrap" v-if="complex.items.length > 0">
          <v-icon class="modern-search-icon">search</v-icon>
          <input
            v-model="search"
            class="modern-search-input"
            placeholder="Search modules..."
          />
        </div>
        <v-spacer v-else></v-spacer>
        <v-btn flat color="secondary" class="table-toolbar-btn" @click="listAllModules">
          <v-icon left small>refresh</v-icon>Refresh
        </v-btn>
        <v-btn depressed color="primary" class="table-toolbar-btn table-toolbar-btn--primary" @click="handleCreateNew">
          <v-icon left small>add</v-icon>Add Module
        </v-btn>
      </div>
      <v-card-text class="pa-0">
        <v-data-table
          :headers="complex.headers"
          :search="search"
          :items="complex.items"
          :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
          item-key="_id"
          class="modern-data-table"
        >
          <template slot="items" slot-scope="props">
            <td class="table-cell-mono">{{ props.item._id }}</td>
            <td>
              <div class="module-chip">
                <v-icon x-small class="module-chip__icon">extension</v-icon>
                {{ props.item.module.replace(/_/g, ' ').toUpperCase() }}
              </div>
            </td>
            <td align="right">
              <v-btn small flat color="primary" class="table-action-btn" @click="moduleEdit(props.item)">
                <v-icon left x-small>edit</v-icon>Edit
              </v-btn>
              <v-btn small flat color="error" class="table-action-btn" @click="moduleDelete(props.item)">
                <v-icon left x-small>delete</v-icon>Delete
              </v-btn>
            </td>
          </template>
          <template slot="no-data">
            <div class="modern-empty-state">
              <v-icon class="modern-empty-state__icon">extension</v-icon>
              <p class="modern-empty-state__text">No modules yet</p>
              <v-btn depressed color="primary" small @click="handleCreateNew">Add First Module</v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import APIModule from "@/mixins/APIModule";
import ConfirmDelete from "@/mixins/confirmDelete";
import FormTextField from "@/components/form/FormTextField";
export default {
  components: {
    FormTextField
  },
  mixins: [APIModule, ConfirmDelete],
  data() {
    return {
      mod: {},
      addModule: false,
      search: "",
      complex: {
        selected: [],
        headers: [
          { text: "Id", value: "_id", sortable: false },
          { text: "Module", value: "module", align: "left", sortable: false },
          { text: "", value: "", sortable: false }
        ],
        items: []
      }
    };
  },
  mounted() {
    this.listAllModules();
  },
  methods: {
    listAllModules: async function() {
      let modules = await this.getModules();
      this.complex.items = modules;
    },
    moduleDelete: async function(mod) {
      const result = await this.confirmDeleteAction({
        title: "Delete this module?",
        text: "This module will be removed from the module list.",
        confirmButtonText: "Delete Module"
      });
      if (!result || !result.value) return;
      try {
        await this.deleteModule(mod._id);
        await this.listAllModules();
        this.$toast.success("Module deleted successfully.", "Success", { position: "topCenter" });
      } catch (error) {}
    },
    createModule: async function() {
      try {
        if (this.mod) {
          this.mod.module = this.mod.module.replace(" ", "_").toLowerCase();
        }
        await this.createNewModule(this.mod);
        this.mod = {};
        this.addModule = false;
        await this.listAllModules();
      } catch (error) {}
    },
    moduleEdit: function(mod) {
      this.mod = mod;
      this.addModule = true;
    },
    handleCreateNew: function() {
      this.mod = {};
      this.addModule = true;
    }
  }
};
</script>

<style scoped lang="css">
/* Dialog */
.module-dialog { border-radius: 16px !important; overflow: hidden; }

.modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 20px 20px 16px;
}
.modal-header__left { display: flex; align-items: center; gap: 14px; }
.modal-header__icon-wrap {
  width: 42px; height: 42px; border-radius: 12px;
  background: linear-gradient(135deg, #1565C0, #0d47a1);
  display: flex; align-items: center; justify-content: center;
}
.modal-header__icon { color: #ffffff !important; font-size: 20px !important; }
.modal-header__title {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 16px;
  font-weight: 700; color: #1e293b;
}
.modal-header__sub { font-family: 'Inter', 'Roboto', sans-serif; font-size: 12px; color: #94a3b8; margin-top: 2px; }
.modal-close-btn { color: #94a3b8 !important; }
.modal-divider { border-color: #f1f5f9 !important; }

.modal-body { padding: 20px; }
.modal-footer {
  display: flex; align-items: center; justify-content: flex-end;
  gap: 8px; padding: 14px 20px;
}
.modal-cancel-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 500 !important;
  text-transform: none !important; color: #64748b !important; border-radius: 10px !important;
}
.modal-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 600 !important;
  text-transform: none !important; border-radius: 10px !important;
  height: 40px !important; padding: 0 20px !important;
  box-shadow: 0 2px 8px rgba(21,101,192,0.3) !important;
}

/* Table */
.modern-table-card { border-radius: 14px !important; overflow: hidden; }
.modern-table-toolbar {
  display: flex; align-items: center; padding: 14px 16px; gap: 8px;
}
.modern-search-wrap {
  flex: 1; display: flex; align-items: center;
  background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px;
  padding: 8px 14px; gap: 10px; transition: border-color 0.2s ease;
}
.modern-search-wrap:focus-within { border-color: #1565C0; background: #ffffff; }
.modern-search-icon { color: #94a3b8 !important; font-size: 18px !important; }
.modern-search-input {
  border: none; outline: none; background: transparent;
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 14px; color: #334155; width: 100%;
}
.modern-search-input::placeholder { color: #94a3b8; }

.table-toolbar-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 500 !important;
  text-transform: none !important; border-radius: 10px !important; height: 38px !important;
}
.table-toolbar-btn--primary {
  box-shadow: 0 2px 8px rgba(21,101,192,0.3) !important;
}

.table-cell-mono {
  font-family: 'SF Mono', 'Roboto Mono', monospace;
  font-size: 12px !important; color: #94a3b8 !important;
  max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

.module-chip {
  display: inline-flex; align-items: center; gap: 6px;
  background: rgba(21,101,192,0.08); color: #1565C0;
  padding: 4px 12px; border-radius: 8px;
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 12px; font-weight: 700;
  letter-spacing: 0.5px;
}
.module-chip__icon { color: #1565C0 !important; }

.table-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 500 !important;
  text-transform: none !important; border-radius: 7px !important;
  height: 30px !important; min-width: unset !important;
  padding: 0 10px !important; font-size: 12px !important; margin: 0 2px !important;
}

.modern-empty-state {
  padding: 60px 24px; text-align: center;
  display: flex; flex-direction: column; align-items: center; gap: 12px;
}
.modern-empty-state__icon { font-size: 48px !important; color: #cbd5e1 !important; }
.modern-empty-state__text {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 15px; color: #94a3b8; margin: 0;
}
</style>
